import { render, staticRenderFns } from "./healthTop.vue?vue&type=template&id=5da74086&scoped=true"
import script from "./healthTop.vue?vue&type=script&lang=js"
export * from "./healthTop.vue?vue&type=script&lang=js"
import style0 from "./healthTop.vue?vue&type=style&index=0&id=5da74086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da74086",
  null
  
)

export default component.exports